import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  connectionError: {
    id: 'authoring.alert.error.connection',
    defaultMessage: 'We encountered a technical error when loading this page. This might be a temporary issue, so please try again in a few minutes. If the problem persists, please go to the {supportLink} for help.',
    description: 'Error message shown to users when there is a connectivity issue with the server.',
  },
  supportText: {
    id: 'authoring.alert.support.text',
    defaultMessage: 'Support Page',
  },
  studioHome: {
    id: 'header.user.menu.studioHome',
    defaultMessage: 'Studio Home',
    description: 'Navigation link for Studio Home',
  },
  layoutMenu: {
    id: 'header.user.menu.manu',
    defaultMessage: 'MENU',
    description: 'MANU TEXT',
  },
  layoutApprovals: {
    id: 'header.user.menu.Approvals',
    defaultMessage: 'Approvals',
    description: 'Enrollments TEXT',
  },
  layoutEnrollments: {
    id: 'header.user.menu.Enrollments',
    defaultMessage: 'Enrollments',
    description: 'Enrollments TEXT',
  },
  layoutSelectAll: {
    id: 'adminpanel.selectall',
    defaultMessage: 'Select All',
    description: 'Select All TEXT',
  },
  dashboard: {
    id: 'header.user.menu.dashboard',
    defaultMessage: 'Dashboard',
    description: 'Navigation link for user dashboard',
  },
  signOut: {
    id: 'header.user.menu.signOut',
    defaultMessage: 'Sign Out',
    description: 'Navigation link for signing out of the platform',
  },
  layoutShow: {
    id: 'adminpanel.show',
    defaultMessage: 'Show',
    description: 'Label for displaying entries',
  },
  layoutEntries: {
    id: 'adminpanel.entries',
    defaultMessage: 'entries',
    description: 'Text for number of table entries',
  },
  layoutSearch: {
    id: 'adminpanel.search',
    defaultMessage: 'Search',
    description: 'Search bar label',
  },
  layoutSelectAll: {
    id: 'adminpanel.selectall',
    defaultMessage: 'Select All',
    description: 'Select All TEXT',
  },
  layoutID: {
    id: 'adminpanel.id',
    defaultMessage: 'ID',
    description: 'Column header for ID',
  },
  layoutUsername: {
    id: 'adminpanel.username',
    defaultMessage: 'Username',
    description: 'Column header for Username',
  },
  layoutCourseName: {
    id: 'adminpanel.courseName',
    defaultMessage: 'Course Name',
    description: 'Column header for Course Name',
  },
  layoutStatus: {
    id: 'adminpanel.status',
    defaultMessage: 'Status',
    description: 'Column header for Status',
  },
  layoutIsActive: {
    id: 'adminpanel.isActive',
    defaultMessage: 'Is Active',
    description: 'Column header for Is Active status',
  },
  layoutShowingEntries: {
    id: 'adminpanel.showingEntries',
    defaultMessage: 'Showing {start} to {end} of {total} entries',
    description: 'Text for pagination info',
  },
  layoutPrevious: {
    id: 'adminpanel.previous',
    defaultMessage: 'Previous',
    description: 'Button label for previous page navigation',
  },
  layoutNext: {
    id: 'adminpanel.next',
    defaultMessage: 'Next',
    description: 'Button label for next page navigation',
  },
  layoutSelectStatus: {
    id: 'adminpanel.selectstatus',
    defaultMessage: 'Select Status',
    description: 'Dropdown placeholder for selecting status',
  },
  layoutApproved: {
    id: 'adminpanel.approved',
    defaultMessage: 'Approved',
    description: 'Option for approved status',
  },
  layoutRejected: {
    id: 'adminpanel.rejected',
    defaultMessage: 'Rejected',
    description: 'Option for rejected status',
  },
  layoutUpdateStatus: {
    id: 'adminpanel.updatestatus',
    defaultMessage: 'Update Status',
    description: 'Button label for updating status',
  },
  columnSelect: {
    id: 'table.column.select',
    defaultMessage: 'Select',
    description: 'Column header for selecting rows',
  },
  columnID: {
    id: 'table.column.id',
    defaultMessage: 'ID',
    description: 'Column header for ID',
  },
  columnUsername: {
    id: 'table.column.username',
    defaultMessage: 'Username',
    description: 'Column header for Username',
  },
  columnCourseName: {
    id: 'table.column.courseName',
    defaultMessage: 'Course Name',
    description: 'Column header for Course Name',
  },
  columnStatus: {
    id: 'table.column.status',
    defaultMessage: 'Status',
    description: 'Column header for Status',
  },
  columnIsActive: {
    id: 'table.column.isActive',
    defaultMessage: 'Is Active',
    description: 'Column header for Is Active status',
  },
  active: {
    id: 'table.cell.active',
    defaultMessage: 'Active',
    description: 'Label for active status',
  },
  inactive: {
    id: 'table.cell.inactive',
    defaultMessage: 'Inactive',
    description: 'Label for inactive status',
  },
  showingEntries: {
    id: 'table.pagination.showingEntries',
    defaultMessage: 'Showing {startIndex} to {endIndex} of {totalCount} entries',
    description: 'Text for pagination info',
  },
  bulkEnrollment: {
    id: 'bulk.enrollment.title',
    defaultMessage: 'Bulk Enrollment',
    description: 'Title for the bulk enrollment page',
  },
  bulkEnrollButton: {
    id: 'bulk.enrollment.button',
    defaultMessage: 'Bulk Enroll',
    description: 'Button text for starting bulk enrollment',
  },
  uploadCSVHeader: {
    id: 'bulk.enrollment.uploadCSV.header',
    defaultMessage: 'Upload CSV File',
    description: 'Header for the upload CSV modal',
  },
  uploadCSVLabel: {
    id: 'bulk.enrollment.uploadCSV.label',
    defaultMessage: 'Please Click Here To Upload CSV File',
    description: 'Label for the file input field',
  },
  fileName: {
    id: 'bulk.enrollment.fileName',
    defaultMessage: 'File: {fileName}',
    description: 'Displays the uploaded file name',
  },
  invalidFile: {
    id: 'bulk.enrollment.invalidFile',
    defaultMessage: 'Please upload a valid CSV file.',
    description: 'Error message when an invalid file is uploaded',
  },
  cancel: {
    id: 'bulk.enrollment.cancel',
    defaultMessage: 'Cancel',
    description: 'Cancel button text',
  },
  submit: {
    id: 'bulk.enrollment.submit',
    defaultMessage: 'Submit',
    description: 'Submit button text',
  },
  sampleFile: {
    id: 'bulk.enrollment.sampleFile',
    defaultMessage: 'Sample File For Bulk User Creation',
    description: 'Text for sample file download',
  },
  clickHere: {
    id: 'bulk.enrollment.clickHere',
    defaultMessage: 'Click Here',
    description: 'Text for download link',
  },
  toDownload: {
    id: 'bulk.enrollment.toDownload',
    defaultMessage: ' to Download.',
    description: 'Text after the download link',
  },
  confirmation: {
    id: 'bulk.enrollment.confirmation',
    defaultMessage: 'Confirmation',
    description: 'Header for the confirmation modal',
  },
  confirmBulkEnroll: {
    id: 'bulk.enrollment.confirmBulkEnroll',
    defaultMessage: 'Are you sure you want to proceed with bulk enrollment?',
    description: 'Message in the confirmation modal',
  },
  no: {
    id: 'bulk.enrollment.no',
    defaultMessage: 'No',
    description: 'Button text for rejecting confirmation',
  },
  yes: {
    id: 'bulk.enrollment.yes',
    defaultMessage: 'Yes',
    description: 'Button text for confirming bulk enrollment',
  },
  success: {
    id: 'bulk.enrollment.success',
    defaultMessage: 'Success',
    description: 'Header for the success modal',
  },
  uploadSuccess: {
    id: 'bulk.enrollment.uploadSuccess',
    defaultMessage: 'File uploaded successfully!',
    description: 'Message displayed on successful upload',
  },
  close: {
    id: 'bulk.enrollment.close',
    defaultMessage: 'Close',
    description: 'Button text for closing modals',
  },
  error: {
    id: 'bulk.enrollment.error',
    defaultMessage: 'Error',
    description: 'Header for the error modal',
  },
  uploadError: {
    id: 'bulk.enrollment.uploadError',
    defaultMessage: 'Error uploading CSV. Please try again.',
    description: 'Message displayed when file upload fails',
  },
  noRowSelected: {
    id: 'alert.norowselected',
    defaultMessage: 'No Row Selected.',
    description: 'Message displayed when No Row Selected.',
  }, selectStatusBeforeUpdate: {
    id: 'alert.selectstatusbeforeupdate',
    defaultMessage: 'Please select a status before updating.',
    description: 'Message displayed when no status is selected before update.',
  },
  statusUpdatedSuccessfully: {
    id: 'alert.statusupdatedsuccessfully',
    defaultMessage: 'Status updated successfully.',
    description: 'Message displayed when the status is updated successfully.',
  },

  failedToUpdateStatus: {
    id: 'alert.failedtoupdatestatus',
    defaultMessage: 'Failed to update status.',
    description: 'Message displayed when the status update fails.',
  },

  uploadCsvFirst: {
    id: 'alert.uploadcsvfirst',
    defaultMessage: 'Please upload a CSV file first.',
    description: 'Message displayed when the user tries to proceed without uploading a CSV file.',
  },

});

export default messages;
